import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Home } from './Home';
import { Details } from './details';
import { Agreement } from './Agreement';
import { Statements } from './Statements';
import { Repayments } from './Repayments';
import { ChangeEmail } from './ChangeEmail';
import { ChangeAddress } from './ChangeAddress';
import { ChangeNumbers } from './ChangeNumbers';
import { Gateway } from '../BaseUrl';
import ChangePassword from './ChangePassword';
import { Loading } from './Loading';
import { PageNotFound } from './PageNotFound';
import { ErrorPage } from './ErrorPage';
import { Get } from '../Ajax';
import { MakePayment } from './MakePayment/MakePayment';

export default class Dashboard extends Component {
    displayName = Dashboard.name  
    _isMounted = false;
    constructor(props) {
        super(props);

        this.state = {
            isBorrower: true,
            loading: false,
            hasError: false,
            address: [],
            dateOfBirth: [],
            emailAddress: [],
            name: [],
            personIds: [],
            counties: [],
            phoneNumbers: [],
            loans: [],
            loan: {},
            summary: {}
        }
               
        this.getUsersInformation = this.getUsersInformation.bind(this);                
    }

    async componentDidMount() {
        this._isMounted = true;
        await this.getUsersInformation();
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    updateState(object, func = () => { }) {
        if (this._isMounted) {
            this.setState(object, func);
        }
    }
    
    async getUsersInformation(load = true) {
        this.updateState({
            loading: load
        });

        try {
            let data = await Get(Gateway + '/Application/Information', "json", () => this.props.Logout(true));

            if (data != null) {
                this.updateState({
                    name: data.personInfo.names[0],
                    address: data.personInfo.addresses[0],
                    emailAddress: data.personInfo.emailAddresses[0],
                    dateOfBirth: data.personInfo.datesOfBirth[0],
                    phoneNumbers: data.personInfo.telephoneNumbers,
                    personIds: data.personInfo.personIDs,
                    loans: data.productDetails,
                    loan: data.productDetails[0]
                }, () => {
                     this.getSummary(load)
                });
            }
        } catch (e) {
            console.error("error in getUsersInformation", e);
            this.updateState({
                loading: false,
                hasError: true
            });
        }

    };

    async getSummary(load = false) {
        try {
            this.updateState({
                loading: load
            });

            let data = await Get(Gateway + '/loan/' + this.state.loan.loanReferenceNumber + '/Summary', "json", () => this.props.Logout(true));

            if (data != null) {
                let isBorrower = true;
                if (data.borrowerName != null) isBorrower = false;

                this.updateState({
                    loading: false,
                    summary: data,
                    isBorrower: isBorrower
                }, await this.getCounties());
            }
        } catch (e) {
            console.error("Error getting summary", e);
            this.updateState({
                loading: false,
                hasError: true
            });
        }
    };
            
    async getCounties() {
        try {
            var counties = localStorage.getItem('counties');
            if (counties == null) {
                let data = await Get(Gateway + '/counties', "json", () => this.props.Logout(true));
                this.updateState({
                    counties: data.sort(this.sortAlphaNum)
                });
                localStorage.setItem('counties', JSON.stringify(data.sort(this.sortAlphaNum)));
            } else {
                this.updateState({
                    counties: JSON.parse(counties)
                });
            }
        } catch (e) {
            console.error("Error getting counties", e);
        }        
    }

  render() {
      return (
        this.state.loading ? <Loading changeLogo={(e) => this.props.changeLogo(e)} /> :
        this.state.hasError ? <ErrorPage changeLogo={(e) => this.props.changeLogo(e)} /> :
        <Switch>
            <Route exact path='/' render={(props) => (<Home token={this.props.token} {...this.state} Logout={(e) => {  this.props.Logout(e) }} changeLogo={(e, a) => this.props.changeLogo(e, a)} /> )} />                    
            <Route path='/details' render={(props) => (<Details token={this.props.token} {...this.state} Logout={(e) => {  this.props.Logout(e) }} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/agreements' render={(props) => (<Agreement token={this.props.token}  {...this.state} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/statements' render={(props) => (<Statements token={this.props.token}  {...this.state} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/repayments' render={(props) => (<Repayments token={this.props.token} {...this.state.summary}  {...this.state} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/change-address' render={(props) => (<ChangeAddress token={this.props.token}  {...this.state} updateUser={() => this.getUsersInformation(false)} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/change-email' render={(props) => (<ChangeEmail token={this.props.token}  {...this.state} updateUser={() => this.getUsersInformation(false)} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} /> )} />                    
            <Route path='/change-numbers' render={(props) => (<ChangeNumbers token={this.props.token}  {...this.state} updateUser={() => this.getUsersInformation(false)} Logout={(e) => {  this.props.Logout(e)}} changeLogo={(e) => this.props.changeLogo(e)} />)} />
            <Route path='/change-password' render={(props) => (<ChangePassword token={this.props.token}  {...this.state} Logout={(e) => { this.props.Logout(e) }} changeLogo={(e) => this.props.changeLogo(e)} />)} />
            <Route path='/make-payment' render={(props) => (<MakePayment reloadPage={() => this.getSummary(false)} token={this.props.token} {...this.state} Logout={(e) => { this.props.Logout(e) }} changeLogo={(e) => this.props.changeLogo(e)} />)} />
            <Route component={(props) => (<PageNotFound />)} />                                
        </Switch>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard.js